import React from "react";
import { FormattedMessage } from "react-intl";

// Shared snippet catalog. Consumers reference the camelCase JS keys
// (e.g. `commonTranslations.fullName`). The `id` props match the keys
// in locales/<code>.json. Keep this file the single place that wires
// JSX to translation ids — adding a one-off `<FormattedMessage>` at
// a component site is fine for truly local copy.
export const commonTranslations = {
  // common.*
  loading: (
    <FormattedMessage id="common.loading" defaultMessage="Loading" />
  ),
  viewAll: (
    <FormattedMessage id="common.viewAll" defaultMessage="View all" />
  ),
  vote: (
    <FormattedMessage id="common.vote" defaultMessage="Vote" />
  ),
  postDelete: (
    <FormattedMessage id="common.deleteYes" defaultMessage="Yes, delete" />
  ),
  postDontDelete: (
    <FormattedMessage id="common.deleteNo" defaultMessage="No, don't" />
  ),
  termsAndConditions: (
    <FormattedMessage id="common.termsAndConditions" defaultMessage="Terms and Conditions" />
  ),
  privacyPolicy: (
    <FormattedMessage id="common.privacyPolicy" defaultMessage="Privacy Policy" />
  ),

  // auth.*
  signin: (
    <FormattedMessage id="auth.signin" defaultMessage="Sign in" />
  ),
  signup: (
    <FormattedMessage id="auth.signup" defaultMessage="Sign up" />
  ),
  signWithEmail: (
    <FormattedMessage id="auth.signInWithEmail" defaultMessage="Sign in with email" />
  ),
  signWithPhone: (
    <FormattedMessage id="auth.signInWithPhone" defaultMessage="Sign in with phone" />
  ),
  signinWithPhone: (
    <FormattedMessage id="auth.signInWithPhone" defaultMessage="Sign in with phone" />
  ),
  verify: (
    <FormattedMessage id="auth.verify" defaultMessage="Verify" />
  ),
  verification: (
    <FormattedMessage id="auth.verification" defaultMessage="Verification" />
  ),
  resendCode: (
    <FormattedMessage id="auth.resendCode" defaultMessage="Resend code" />
  ),
  codeHasBeenResend: (
    <FormattedMessage id="auth.codeResent" defaultMessage="Code has been resent" />
  ),
  alreadyHaveAccount: (
    <FormattedMessage id="auth.alreadyHaveAccount" defaultMessage="Already have an account?" />
  ),
  dontHaveAccount: (
    <FormattedMessage id="auth.dontHaveAccount" defaultMessage="Don't have an account?" />
  ),
  phoneNumberHere: (
    <FormattedMessage id="auth.phone.placeholder" defaultMessage="Phone number here" />
  ),

  // post.*
  title: (
    <FormattedMessage id="post.field.title" defaultMessage="Title" />
  ),
  addTitleHere: (
    <FormattedMessage id="post.field.title.placeholder" defaultMessage="Add title here" />
  ),
  description: (
    <FormattedMessage id="post.field.description" defaultMessage="Description" />
  ),
  addDescriptionHere: (
    <FormattedMessage id="post.field.description.placeholder" defaultMessage="Add description here" />
  ),
  type: (
    <FormattedMessage id="post.field.type" defaultMessage="Type" />
  ),
  gender: (
    <FormattedMessage id="post.field.gender" defaultMessage="Gender" />
  ),
  condition: (
    <FormattedMessage id="post.field.condition" defaultMessage="Condition" />
  ),
  price: (
    <FormattedMessage id="post.field.price" defaultMessage="Price" />
  ),
  discountedPrice: (
    <FormattedMessage id="post.field.discount" defaultMessage="Discounted price" />
  ),
  // Checkbox label — opt-in to enter a discounted price. Distinct from
  // `discountedPrice` above, which still labels the actual numeric input
  // that appears below the checkbox once it's ticked.
  discountToggle: (
    <FormattedMessage id="post.field.discountToggle" defaultMessage="Offer a discounted price" />
  ),
  postNow: (
    <FormattedMessage id="post.button.postNow" defaultMessage="Post now" />
  ),
  preloved: (
    <FormattedMessage id="post.condition.preLoved" defaultMessage="Pre-loved" />
  ),

  // home.*
  latest: (
    <FormattedMessage id="home.tab.latest" defaultMessage="Latest" />
  ),

  // profile.*
  fullName: (
    <FormattedMessage id="profile.field.fullName" defaultMessage="Full name" />
  ),
  brandName: (
    <FormattedMessage id="profile.field.brandName" defaultMessage="Brand name" />
  ),
  contact: (
    <FormattedMessage id="profile.field.contactNumber" defaultMessage="Contact number" />
  ),
  email: (
    <FormattedMessage id="profile.field.email" defaultMessage="Email" />
  ),
  password: (
    <FormattedMessage id="profile.field.password" defaultMessage="Password" />
  ),

  // social.*
  facebook: (
    <FormattedMessage id="social.facebook" defaultMessage="Facebook" />
  ),
  instagram: (
    <FormattedMessage id="social.instagram" defaultMessage="Instagram" />
  ),
  twitter: (
    <FormattedMessage id="social.twitter" defaultMessage="Twitter" />
  ),
  tiktok: (
    <FormattedMessage id="social.tiktok" defaultMessage="Tiktok" />
  ),

  // country.*
  notAllowedCountry: (
    <FormattedMessage
      id="country.notAllowed"
      defaultMessage="We are still expanding. If you want us to bring dresez to your country soon, drop a vote below."
    />
  ),
  votePlaced: (
    <FormattedMessage id="country.votePlaced" defaultMessage="Vote placed" />
  ),

  // cookie.*
  cookieText: (
    <FormattedMessage
      id="cookie.text"
      defaultMessage="dresez.com uses cookies and browser storage to save data related to user and its preferences. Also it collects data related to user experience for improving the performance and to deliver the best possible value. By tapping on accept you agree to dresez.com {terms}. See {privacy}."
    />
  ),

  // error.*
  required: (
    <FormattedMessage id="error.required" defaultMessage="Required field" />
  ),
  enterValidEmail: (
    <FormattedMessage id="error.invalidEmail" defaultMessage="Please enter a valid email" />
  ),
  invalidPhone: (
    <FormattedMessage id="error.invalidPhone" defaultMessage="Invalid phone number" />
  ),
  priceIsMax: (
    <FormattedMessage id="error.discountTooHigh" defaultMessage="Discounted price should be less than the actual price" />
  ),
};
